import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FaRocket, FaStar, FaCheckCircle, FaChevronRight } from "react-icons/fa";
import "../sell-fast-page/info-page.css";

const TIERS = [
  {
    icon: <FaRocket size={22} color="#ed1b24" />,
    name: "Boosted",
    badge: "Popular",
    badgeColor: "#ed1b24",
    highlights: [
      "Pushed to the top of relevant search results",
      "Up to 10× more views than a standard listing",
      "Appears above non-boosted ads in your category",
      "Ideal for sellers who want a quick sale",
    ],
  },
  {
    icon: <FaStar size={22} color="#f59e0b" />,
    name: "Premium",
    badge: "Best Visibility",
    badgeColor: "#f59e0b",
    highlights: [
      "Featured in the premium spotlight section on listing pages",
      "Maximum exposure across all browse and search views",
      "Highlighted with a premium badge to attract serious buyers",
      "Best choice for high-value vehicles and dealer stock",
    ],
  },
];

function BoostAdPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="info-page">
      <div className="container">
        <div className="info-page__card">

          <div className="info-page__hero">
            <p className="info-page__eyebrow">Seller Feature</p>
            <h1 className="info-page__title">Boost Your Ad</h1>
            <p className="info-page__subtitle">
              Get your vehicle in front of more buyers, faster. Boosting puts your listing at the top — before the competition.
            </p>
          </div>

          <div className="info-page__body">

            <div className="info-section" style={{ flexDirection: "column", gap: "0.5rem" }}>
              <h3 className="info-section__title">Why Boost?</h3>
              <ul className="info-section__list">
                {[
                  "Hundreds of new listings are added every day — boosting keeps yours visible at the top.",
                  "Boosted ads receive significantly more views and enquiries than standard listings.",
                  "Sell faster: most boosted listings attract their first enquiry within hours.",
                  "Simple to activate — log in, go to My Ads, and boost any active listing in seconds.",
                ].map((p, i) => (
                  <li key={i}>
                    <FaCheckCircle size={13} color="#22c55e" style={{ flexShrink: 0, marginTop: 2 }} />
                    {p}
                  </li>
                ))}
              </ul>
            </div>

            <div className="row g-3">
              {TIERS.map((tier, i) => (
                <div key={i} className="col-sm-12 col-md-6">
                  <div className="info-section" style={{ flexDirection: "column", height: "100%", position: "relative" }}>
                    <div style={{ display: "flex", alignItems: "center", gap: "0.75rem", marginBottom: "0.25rem" }}>
                      <div className="info-section__icon-wrap" style={{ width: 40, height: 40 }}>{tier.icon}</div>
                      <h3 className="info-section__title" style={{ margin: 0 }}>{tier.name}</h3>
                      <span style={{ fontSize: "0.7rem", fontWeight: 700, background: tier.badgeColor, color: "#fff", borderRadius: "50rem", padding: "2px 8px" }}>{tier.badge}</span>
                    </div>
                    <ul className="info-section__list">
                      {tier.highlights.map((h, j) => (
                        <li key={j}>
                          <FaCheckCircle size={13} color="#22c55e" style={{ flexShrink: 0, marginTop: 2 }} />
                          {h}
                        </li>
                      ))}
                    </ul>
                  </div>
                </div>
              ))}
            </div>

            <div className="info-section" style={{ flexDirection: "column", gap: "0.5rem", background: "#fafafa" }}>
              <h3 className="info-section__title">How to Boost Your Listing</h3>
              <ul className="info-section__list">
                {[
                  "Sign in to your AdsOne account.",
                  "Go to 'My Ads' from the navigation menu.",
                  "Find the listing you want to boost and click the options menu.",
                  "Select 'Boost' and choose your preferred boost tier.",
                  "Your ad will be promoted immediately after confirmation.",
                ].map((p, i) => (
                  <li key={i}>
                    <span style={{ background: "#ed1b24", color: "#fff", borderRadius: "50%", width: 18, height: 18, display: "inline-flex", alignItems: "center", justifyContent: "center", fontSize: "0.65rem", fontWeight: 700, flexShrink: 0 }}>{i + 1}</span>
                    {p}
                  </li>
                ))}
              </ul>
            </div>

          </div>

          <div className="info-page__cta">
            <h3>Ready to boost?</h3>
            <p>Log in to your account and boost any active listing in seconds.</p>
            <Link to="/ad-settings" className="btn px-5 py-2 fw-bold" style={{ borderRadius: "50rem" }}>
              Go to My Ads <FaChevronRight size={12} />
            </Link>
          </div>

        </div>
      </div>
    </div>
  );
}

export default BoostAdPage;
